import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=6a8903e1"
import script from "./phone.vue?vue&type=script&lang=ts"
export * from "./phone.vue?vue&type=script&lang=ts"
import style0 from "./phone.vue?vue&type=style&index=0&id=6a8903e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports